const get_time = (date_time: string | number) => {
  return date_time
    ? get_date(date_time)
    : '--/--/---- --:--:--';
};

const get_date = (date_time: string | number) => {
  let oDate = new Date(date_time),
    oYear = oDate.getFullYear(),
    oMonth = oDate.getMonth() + 1,
    oDay = oDate.getDate(),
    oHour = oDate.getHours(),
    oMin = oDate.getMinutes(),
    oSen = oDate.getSeconds(),
    oTime = oYear + '-' + add_zero(oMonth) + '-' + add_zero(oDay) + ' ' + add_zero(oHour) + ':' +
      add_zero(oMin) + ':' + add_zero(oSen);
  return oTime;
}

//补零操作
const add_zero = (num: any) =>  {
  if (parseInt(num) < 10) {
    num = '0' + num;
  }
  return num;
}

export default get_time;
